<!-- Copyright (c) ArubaCC - All Rights Reserved. -->

<button (click)="resetAllFilters()" mat-button class="font-bold" color="primary">
  {{ 'COMMON.BUTTON.RESET_ALL_FILTERS' | transloco }}
</button>
